import { Component, OnInit, HostListener } from '@angular/core';
import * as AOS from 'aos';
import { ConnectionService } from "./_services/connection.service";
import { MatSnackBar } from '@angular/material/snack-bar';
// import swal from 'sweetalert2';
// import { ToastrService } from "ngx-toastr";
@Component({
  selector: "app-root",
  templateUrl: "./app.component.html",
  styleUrls: ["./app.component.scss"],
  animations: []
})
export class AppComponent implements OnInit {
  title = "ros-application";
  isShow: boolean;
  topPosToStartShowing = 100;
  @HostListener("window:scroll")
  checkScroll() {
    // window의 scroll top
    // Both window.pageYOffset and document.documentElement.scrollTop returns the same result in all the cases. window.pageYOffset is not supported below IE 9.

    const scrollPosition =
      window.pageYOffset ||
      document.documentElement.scrollTop ||
      document.body.scrollTop ||
      0;

    // console.log("[scroll]", scrollPosition);

    if (scrollPosition >= this.topPosToStartShowing) {
      this.isShow = true;
    } else {
      this.isShow = false;
    }
  }

  // TODO: Cross browsing
  gotoTop() {
    window.scroll({
      top: 0,
      left: 0,
      behavior: "smooth"
    });
  }
  deviceInfo = null;
  status = "";
  isConnected = true;
  checkInternet = "Internet Connection";
  deviceType: any;
  // constructor(private translate: TranslateService) {
  //   translate.setDefaultLang('en');
  // }
  constructor(
    private connectionService: ConnectionService,
    // private toastr: ToastrService
    private snack:MatSnackBar
  ) {
    this.connectionService.monitor().subscribe(isConnected => {
      this.isConnected = isConnected;
      if (this.isConnected) {
        this.status = "ONLINE";
        this.snack.open(this.checkInternet, this.status, {
          duration: 2000,
          // here specify the position
          verticalPosition: "top"
        });
        // this.toastr.success(this.checkInternet, this.status);
        // swal.fire(
        //   'Internet Connection',
        //   this.status,
        //   'success'
        // )
        document.location.reload();
      } else {
        this.status = "OFFLINE";
        this.snack.open(this.checkInternet, this.status, {
          duration: 2000,
          // here specify the position
          verticalPosition: "top"
        });

        // this.toastr.error(this.checkInternet, this.status);
        // swal.fire(
        //   'Internet Connection',
        //   this.status,
        //   'error'
        // )
      }
    });
  }

  onActivate(event) {
    window.scroll(0, 0);
  }

  ngOnInit() {
    AOS.init();
  }
}
